import { render } from "./AttachmentIcon.vue?vue&type=template&id=d1a37b2c&ts=true"
import script from "./AttachmentIcon.vue?vue&type=script&lang=ts"
export * from "./AttachmentIcon.vue?vue&type=script&lang=ts"

import "./AttachmentIcon.vue?vue&type=style&index=0&id=d1a37b2c&lang=scss"

import exportComponent from "../../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__